export default {
  title: 'Seneste kampagneresultater',
  recipients: '{{recipients}} modtagere',
  error_messages: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
